export const CALL_FEATURE_CHARACTER_LIMIT = 10;
export enum Permission {
  VIEW_DEAL_LISTINGS = "ViewDealListing",
  VIEW_DEAL_DETAILS = "ViewDealDetails",
  SAVE_MUNI_ORDER = "SaveMuniOrder",
  SUBMIT_MUNI_ORDERS = "SubmitMuniOrders",
  CANCEL_MUNI_ORDERS = "CancelMuniOrders",
  DELETE_MUNI_ORDER = "DeleteMuniOrder"
}
